export default "__VITE_ASSET__DU3$CI0S__"